<template>
  <component
    :is="illustration"
    :style="illustrationStyles"
  />
</template>

<script>

export default {
  name: 'SnIllustration',
  props: {
    illustration: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      default: 'snPrimary'
    },
    secondaryColor: {
      type: String,
      default: 'snBrand'
    },
    size: {
      type: String,
      required: false,
      default: 'lg',
      validator (type) {
        return ['xs', 'sm', 'md', 'lg', 'xl'].includes(type)
      }
    }
  },
  computed: {
    primaryColorHex () {
      return this.getColorHex(this.primaryColor)
    },
    secondaryColorHex () {
      return this.getColorHex(this.secondaryColor)
    },
    // the height and width sizes come from this figma drawing:
    // https://www.figma.com/file/a6C1uH9KKCwmCBOsZnsknI/Core-components?node-id=1767%3A61538&t=AxLA7z8ytUePuOrI-0
    iconSize () {
      let height = 0
      let width = 0
      switch (this.size) {
        case 'xs':
          height = 44.42
          width = 69.91
          break
        case 'sm':
          height = 59.22
          width = 93.22
          break
        case 'md':
          height = 83.9
          width = 132.06
          break
        case 'lg':
          height = 103.64
          width = 163.13
          break
        case 'xl':
          height = 123.38
          width = 194.21
          break
        default:
          height = 103.64
          width = 163.13
      }
      return {
        height: height + 'px',
        width: width + 'px'
      }
    },
    illustrationStyles () {
      var styles = {}
      if (this.primaryColorHex) { styles['--primary-color'] = this.primaryColorHex }
      if (this.secondaryColorHex) { styles['--secondary-color'] = this.secondaryColorHex }
      const iconSize = this.iconSize
      styles.width = iconSize.width
      styles.height = iconSize.height
      return styles
    }
  },
  watch: {
    illustration (val) {
      this.$options.components[val] = require(`./illustrations/${val}.vue`).default
    }
  },
  created () {
    this.$options.components[this.illustration] = require(`./illustrations/${this.illustration}.vue`).default
  },
  methods: {
    getColorHex (color) {
      if (!color) { return null }
      if (!this.$vuetify?.theme?.themes?.light) { return null }
      var colorHex = this.$vuetify.theme.themes.light[color]
      if (!colorHex) { return null }
      return colorHex
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/assets/css/snui';
</style>
